import React, { useEffect, useContext, useRef } from 'react'
import { useHistory, useParams } from 'react-router-dom'

import { AppLoader } from '@portal/kit/pkg/components'

import { PaymentContext } from 'components/providers/payment'
import { offerPaths } from 'helpers/payment-services'
import OffersBreadcrumb from '../breadcrumb'

const POLLING_INTERVAL = 1000

// Retour de Stripe : la commande est confirmée de manière asynchrone (webhook),
// on recharge la commande tant qu'elle est "pending" puis on affiche la confirmation
export default function ConfirmationInProgress() {
  const { offerId, order_id } = useParams()
  const history = useHistory()
  const { loadOrder } = useContext(PaymentContext)

  // loadOrder change à chaque mise à jour de la commande : on garde la dernière
  // version dans une ref pour ne pas relancer le polling
  const loadOrderRef = useRef(loadOrder)
  loadOrderRef.current = loadOrder

  useEffect(() => {
    let timeout = null
    let cancelled = false

    async function fetchData() {
      const o = await loadOrderRef.current(order_id)
      if (cancelled) return

      if (o && o.status === 'pending') {
        timeout = setTimeout(fetchData, POLLING_INTERVAL)
      } else {
        history.replace(offerPaths(offerId).confirmation.replace(':order_id', order_id))
      }
    }
    fetchData()

    return () => {
      cancelled = true
      clearTimeout(timeout)
    }
  }, [offerId, order_id, history])

  return (
    <>
      <OffersBreadcrumb step="payment" />
      <AppLoader />
    </>
  )
}
